import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class AlchemistAbandoned3PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ALCHEMIST_ABANDONED3;
}

export default AlchemistAbandoned3PoiTileEntity;
